import { useMemo } from 'react';

import { TabPanel } from '@webclient/components/settings/components/tab-panel';
import Contact from '@webclient/components/settings/components/tabs/contact';
import General from '@webclient/components/settings/components/tabs/general';
import KnowledgeBase from '@webclient/components/settings/components/tabs/knowledge-base';
import Search from '@webclient/components/settings/components/tabs/search';
import Voice from '@webclient/components/settings/components/tabs/voice';
import CONFIG, { TAB_ITEMS } from '@webclient/components/settings/config';
import {
  StyledBox,
  StyledIconButton,
  StyledWrapperBox,
} from '@webclient/components/settings/desktop/styles';

import useAppSettingsModal from '@webclient/hooks/useAppSettingsModal';
import useQueryParams from '@webclient/hooks/useQueryParams';

import CloseIcon from '~icons/knowz-iconify/cross';

export type Props = {
  onClose: () => void;
  tab: number | false;
};

export default function Desktop({ onClose, tab }: Props) {
  const tabs = useMemo(
    () => [
      <General onClose={onClose} />,
      <Contact onClose={onClose} />,
      <Search onClose={onClose} />,
      <Voice onClose={onClose} />,
      <KnowledgeBase onClose={onClose} />,
    ],
    [onClose],
  );

  const { getQueryParamByKey, removeQueryParamByKey } = useQueryParams();

  const { isAppSettingsModalOpen, toggleAppSettingsModal } =
    useAppSettingsModal();

  const configQueryParam = getQueryParamByKey<string | null>('config');

  const isAppSettingsUrl = TAB_ITEMS.some(
    (item) => item.routeAlias === configQueryParam,
  );

  return CONFIG.TAB_ITEMS.map((item, index) => (
    <TabPanel
      key={item.id}
      value={tab || 0}
      index={index}
    >
      <StyledWrapperBox>
        <StyledIconButton
          sx={{}}
          color="secondary"
          variant="ghost"
          onClick={() => {
            isAppSettingsUrl && removeQueryParamByKey('config');
            isAppSettingsModalOpen && toggleAppSettingsModal();
          }}
        >
          <CloseIcon />
        </StyledIconButton>
        <StyledBox>{tabs[index]}</StyledBox>
      </StyledWrapperBox>
    </TabPanel>
  ));
}
